$('body').on('click','.cdk-product-tabs .tab-nav .tab-nav-item', function(){
  var tab_index = $(this).attr('data-nav');
  $(this).siblings().removeClass('active');
  $(this).addClass('active');
  $('.cdk-product-tabs .tab-content .tab-content-item').hide();
  $('.cdk-product-tabs .tab-content .tab-content-item[data-content="'+tab_index+'"]').show();
})

$('body').on('click','.color.swatch-element', function(){
  var variant_img_id = $(this).attr('data-img-id');
  //console.log('variant_img_id ::'+variant_img_id );
  //$('.swiper-horiz-thumbnails-main-container .slide_id_"'+variant_img_id+'"').trigger('click');
})

 /***15 oct 25***/
document.addEventListener("DOMContentLoaded", function() {
    let outer_div = document.getElementById('category-sticky-parent');
    let get_views = document.querySelectorAll('.tap-target');
    let list_view_btn = get_views[0]; // Renamed for clarity
    let grid_view_btn = get_views[1]; // Renamed for clarity
    
    if (!outer_div || !list_view_btn || !grid_view_btn) {
        console.error('One or more required elements (parent div or view buttons) not found.');
        return; 
    }

    outer_div.classList.add('grid_view'); 
    
    list_view_btn.addEventListener('click', function() {
        outer_div.classList.remove('grid_view');
        this.classList.add('active');
        grid_view_btn.classList.remove('active');
        outer_div.classList.add('list_view');
    });

    grid_view_btn.addEventListener('click', function() {
        outer_div.classList.remove('list_view');
        this.classList.add('active');
        list_view_btn.classList.remove('active');
        outer_div.classList.add('grid_view');
    });

});